import { Loader2Icon, type LucideProps } from 'lucide-react';

import { cn } from 'components/lib/utils';

function Spinner({ className, color = '#4338ca', ...props }: LucideProps) {
  return (
    <Loader2Icon
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      color={color}
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}
export { Spinner };
